import { useStore } from "zustand";
import { useDashboardName } from "../../store/headerName";
import { useEffect, useState } from "react";
import BaseCard from "../../components/card/BaseCard";
import SalesRatioCard from "../../components/card/SalesRatioCard";
import ButtonIcon from "../../components/ButtonIcon";
import { Button, Dropdown, Form, Modal, Table, Tabs } from "antd";
import type { TableProps } from "antd/lib";
import Status from "../../components/Status";
import { Link } from "react-router";
import { formatDate, numberFormatterLabel } from "../../helper/method";
import { $api, type components } from "../../helper";
import { Icon } from "@iconify/react";
import FilterSearch from "../../components/filter/FilterSearch";
import DatePicker, { DateObject } from "react-multi-date-picker";
import moment from "moment-jalaali";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import FormItemInputTextarea from "../../components/form-item/form-item-input-textarea";
import { useNotify } from "../../helper/notify";
import { tokenMock } from "../../helper/mock";
import ConfirmModal from "../../components/modal/ConfirmModal";
import BaseTable from "../../components/BaseTable";

export default function InvoicesList() {
  const [startDate, setStartDate] = useState<string>("");
  const [endDate, setEndDate] = useState<string>("");
  const { setDashboardName } = useStore(useDashboardName);
  const [description, setDescription] = useState("");
  const notify = useNotify();
  const [id, setId] = useState("");
  const [status, setStatus] = useState(0);
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);
  const { data, isLoading, refetch } = $api.useQuery(
    "get",
    "/site-api/v1/sell-factor/",
  );
  const { mutate, isPending } = $api.useMutation(
    "put",
    "/site-api/v1/sell-factor-description/",
  );
  const deleteFactor = $api.useMutation("delete", "/site-api/v1/sell-factor/");
  const detail = $api.useMutation(
    "get",
    "/site-api/v1/sell-factor-description/",
  );
  useEffect(() => {
    setDashboardName("لیست فاکتور ها");
  }, []);

  const handleChangeStartDate = (date: DateObject) => {
    if (!date) return;
    const isoDate = moment(date.toDate()).format("jYYYY-jMM-jDD HH:mm");
    setStartDate(isoDate);
  };

  const handleChangeEndDate = (date: DateObject) => {
    if (!date) return;
    const isoDate = moment(date.toDate()).format("jYYYY-jMM-jDD HH:mm");
    setEndDate(isoDate);
  };

  const columns: TableProps<
    components["schemas"]["SiteSellFactorItem"]
  >["columns"] = [
    {
      title: "#",
      dataIndex: "key",
      key: "key",
      render: (_, record, index) => <span>{index + 1}</span>,
    },
    {
      title: "مشتری",
      filterDropdown: ({
        setSelectedKeys,
        selectedKeys,
        confirm,
        clearFilters,
      }) => (
        <FilterSearch
          clearFilters={clearFilters}
          confirm={confirm}
          selectedKeys={selectedKeys}
          setSelectedKeys={setSelectedKeys}
        />
      ),
      onFilter: (value, record) =>
        record.user_name
          .toLowerCase()
          .includes(value.toString().toLocaleLowerCase()),
      filterIcon: () => (
        <Icon className="text-xl" icon={"solar:magnifer-linear"} />
      ),
      dataIndex: "image",
      key: "image",
      render: (_, record) => (
        <div className="flex items-center gap-2">
          <img
            src={"/image/avatar-25.webp"}
            alt=""
            className="w-12 rounded-full h-full object-cover"
          />
          <div className="flex flex-col">
            <span className="text-18-regular">{record.user_name}</span>
            <span className="text-16-regular text-grayscale-500">
              {record.user_username}
            </span>
          </div>
        </div>
      ),
    },
    {
      title: "تاریح ایجاد فاکتور",
      dataIndex: "created",
      onFilter: (value, record) => {
        if (!startDate && !endDate) return true;
        const startTime = startDate
          ? moment(startDate, "jYYYY-jMM-jDD HH:mm").toDate().getTime()
          : -Infinity;
        const endTime = endDate
          ? moment(endDate, "jYYYY-jMM-jDD HH:mm").toDate().getTime()
          : Infinity;
        const recordTime = new Date(record.created).getTime();
        if (recordTime >= startTime && recordTime <= endTime) {
          return true;
        } else {
          return false;
        }
      },
      filterDropdown: ({ setSelectedKeys, clearFilters }) => (
        <div className="p-4 flex flex-col gap-2">
          <Form.Item
            className="mb-0! col-span-1"
            label={"تاریخ شروع"}
            layout="vertical"
          >
            <DatePicker
              value={startDate}
              name="sad"
              zIndex={1500}
              onChange={handleChangeStartDate}
              calendar={persian}
              locale={persian_fa}
              inputClass="w-full! z-50! h-11! rounded-lg! border! border-grayscale-200! pr-2!"
              className="w-full! h-full! z-50!"
              containerClassName="!w-full !h-full !z-50"
              format="YYYY/MM/DD"
            ></DatePicker>
          </Form.Item>
          <Form.Item
            className="col-span-1 mb-0!"
            label={"تاریخ اتمام"}
            layout="vertical"
          >
            <DatePicker
              value={endDate}
              name="asdsad"
              zIndex={1000}
              onChange={handleChangeEndDate}
              calendar={persian}
              locale={persian_fa}
              inputClass="w-full! z-50! h-11! rounded-lg! border! border-grayscale-200! pr-2!"
              className="w-full! h-full! z-50!"
              containerClassName="!w-full !h-full !z-50"
              format="YYYY/MM/DD"
            ></DatePicker>
          </Form.Item>
          <div className="flex gap-2 pt-2">
            {/* <Button
              onClick={() => {
                setSelectedKeys([endDate, startDate]);
                confirm();
              }}
              className="w-1/2!"
              type="primary"
            >
              جستجو
            </Button> */}
            <Button
              onClick={() => {
                setSelectedKeys([]);
                setEndDate("");
                setStartDate("");
                clearFilters?.();
              }}
              className="w-full!"
              danger
            >
              حذف فیلتر
            </Button>
          </div>
        </div>
      ),
      key: "created",
      render: (_, record) => (
        <div className="flex flex-col">
          <span className="text-18-regular">{formatDate(record.created)}</span>
        </div>
      ),
    },
    {
      title: "شناسه فاکتور",
      dataIndex: "code",
      key: "code",
    },
    {
      title: "مبلغ خرید",
      key: "total_price",
      dataIndex: "total_price",
      render: (_, record) => (
        <span className="">{numberFormatterLabel(record.price)}</span>
      ),
    },
    {
      title: "وضعیت تحویل",
      key: "order_status",
      dataIndex: "order_status",
      render: (_, record) => (
        <Status
          title={record.delivery_status === 1 ? "تحویل شده" : "تحویل نشده"}
          style={record.delivery_status === 1 ? "success" : "warning"}
        />
      ),
    },
    {
      title: "وضعیت پرداخت",
      key: "status",
      dataIndex: "status",
      render: (_, record) => (
        <Status
          title={
            record.settlement_status === 1 ? "پرداخت شده" : "در انتظار پرداخت"
          }
          style={record.settlement_status === 1 ? "success" : "warning"}
        />
      ),
    },
    {
      title: "عملیات",
      key: "action",
      render: (_, record) => (
        <div className="flex">
          <Dropdown
            trigger={["click"]}
            menu={{
              items: [
                {
                  key: "1",
                  label: (
                    <Link to={`/invoice-detail/${record.u_id}`}>
                      جزئیات فاکتور
                    </Link>
                  ),
                },
                {
                  key: "3",
                  label: (
                    <button
                      onClick={() => {
                        setIsOpen(true);
                        setId(record.u_id);
                        detail.mutate(
                          {
                            params: {
                              query: {
                                sell_factor_u_id: record.u_id,
                              },
                            },
                            headers: {
                              Authorization: tokenMock,
                              lang: "fa",
                            },
                          },
                          {
                            onSuccess: (data) => {
                              setDescription(data.data.description ?? "");
                            },
                          },
                        );
                      }}
                    >
                      توضیحات
                    </button>
                  ),
                },
                {
                  key: "4",
                  danger: true,
                  label: (
                    <button
                      onClick={() => {
                        setId(record.u_id);
                        setIsOpenDeleteModal(true);
                      }}
                    >
                      حذف فاکتور
                    </button>
                  ),
                },
              ],
            }}
            placement="bottom"
          >
            <ButtonIcon icon="solar:menu-dots-bold" className="rotate-90" />
          </Dropdown>
        </div>
      ),
    },
  ];

  const calculator = (filteredLength: number) => {
    const totalLength = data?.data?.length ?? 0;
    return Math.round((filteredLength / totalLength) * 100);
  };

  return (
    <div className="flex flex-col gap-6">
      {/* modal */}
      <Modal
        loading={detail.isPending}
        onCancel={() => setIsOpen(false)}
        open={isOpen}
        closeIcon={false}
        title={"توضیحات فاکتور"}
        footer={false}
      >
        <FormItemInputTextarea
          layout="vertical"
          label={"توضیحات"}
          className="my-6! mb-6!"
          inputProps={{
            rows: 5,
            onChange: (e) => {
              setDescription(e.target.value);
            },
            value: description,
          }}
        />
        <div className="flex gap-1">
          <Button
            loading={isPending}
            onClick={() =>
              mutate(
                {
                  body: {
                    description: description,
                    sell_factor_u_id: id,
                  },
                  headers: {
                    Authorization: tokenMock,
                    lang: "fa",
                  },
                },
                {
                  onSuccess: (data) => {
                    notify.success(data.message);
                    setId("");
                    setIsOpen(false);
                    setDescription("");
                  },
                },
              )
            }
            type="primary"
          >
            تایید
          </Button>
          <Button onClick={() => setIsOpen(false)} danger>
            لغو
          </Button>
        </div>
      </Modal>
      <ConfirmModal
        action={() => {
          deleteFactor.mutate(
            {
              params: {
                query: {
                  sell_factor_u_id: id,
                },
              },
              headers: {
                Authorization: tokenMock,
                lang: "fa",
              },
            },
            {
              onSuccess: (data) => {
                notify.success(data.message);
                setId("");
                setIsOpenDeleteModal(false);
                refetch();
              },
            },
          );
        }}
        description="ایا از حذف این فاکتور مطمعن هستید ؟"
        onClose={() => setIsOpenDeleteModal(false)}
        open={isOpenDeleteModal}
        pending={deleteFactor.isPending}
        title="حذف فاکتور"
      />
      <BaseCard props={{ className: "grid lg:grid-cols-3 grid-cols-1" }}>
        <SalesRatioCard
          percentage={calculator(
            data?.data?.filter((e) => e.settlement_status === 2).length ?? 0,
          )}
          invoiceCount={
            data?.data?.filter((e) => e.settlement_status === 2).length
          }
          amount={
            data?.data
              ?.filter((e) => e.settlement_status === 2)
              ?.reduce((acc, item) => acc + item.price, 0) ?? 0
          }
          icon="solar:sort-by-time-line-duotone"
          color="#f5de1a"
          className="col-span-1"
          title="در انتظار پرداخت"
        />
        <SalesRatioCard
          percentage={calculator(
            data?.data?.filter((e) => e.settlement_status === 1).length ?? 0,
          )}
          invoiceCount={
            data?.data?.filter((e) => e.settlement_status === 1).length
          }
          amount={
            data?.data
              ?.filter((e) => e.settlement_status === 1)
              ?.reduce((acc, item) => acc + item.price, 0) ?? 0
          }
          icon="solar:file-check-bold-duotone"
          color="#16cc90"
          className="col-span-1"
          title="پرداخت شده"
        />
        <SalesRatioCard
          percentage={100}
          amount={data?.data.reduce((sum, item) => sum + item.price, 0) ?? 0}
          invoiceCount={data?.data?.length}
          icon="solar:bill-list-bold-duotone"
          color="#069af1"
          className="col-span-1"
          title="جمع کل"
        />
      </BaseCard>

      <BaseCard
        props={{
          className: "p-0! flex flex-col gap-6",
        }}
      >
        <div className="w-full flex gap-6 items-center">
          <Tabs
            direction="rtl"
            onChange={(e) => setStatus(Number(e))}
            classNames={{
              header: "px-6! overflow-auto!",
            }}
            defaultActiveKey="0"
            className="w-full"
            items={[
              {
                key: "0",
                label: (
                  <button className="text-16-bold flex gap-1 items-center cursor-pointer">
                    <span className="lg:text-16-semi-bold text-14-regular">
                      همه
                    </span>
                    <div className="lg:w-9 px-2! rounded-sm aspect-square bg-black text-white flex-center">
                      {data?.data.length}
                    </div>
                  </button>
                ),
              },
              {
                key: "1",
                label: (
                  <button className="text-16-bold flex gap-1 items-center cursor-pointer">
                    <span className="lg:text-16-semi-bold text-14-regular">
                      پرداخت شده
                    </span>
                    <div className="lg:w-9 px-2! rounded-sm aspect-square bg-success-100 text-success-600 flex-center">
                      {
                        data?.data?.filter((e) => e.settlement_status === 1)
                          .length
                      }
                    </div>
                  </button>
                ),
              },
              {
                key: "2",
                label: (
                  <button className="text-16-bold flex gap-1 items-center cursor-pointer">
                    <span className="lg:text-16-semi-bold text-14-regular">
                      در انتظار پرداخت
                    </span>
                    <div className="lg:w-9 px-2! rounded-sm aspect-square bg-warning-100 text-warning-600 flex-center">
                      {
                        data?.data?.filter((e) => e.settlement_status === 2)
                          .length
                      }
                    </div>
                  </button>
                ),
              },
            ]}
          />
        </div>
        <div className="w-full flex gap-6 px-0">
          <BaseTable props={{ className: "w-full grid! grid-cols-1!" }}>
            <Table<components["schemas"]["SiteSellFactorItem"]>
              className="col-span-1!"
              scroll={{ x: "max-content" }}
              loading={isLoading}
              columns={columns}
              dataSource={
                status
                  ? data?.data.filter((e) => e.settlement_status === status)
                  : data?.data
              }
            />
          </BaseTable>
        </div>
      </BaseCard>
    </div>
  );
}
